import React from 'react';

export default function RefundLedgerPanel({ ledger }) {
  if (!ledger) return null;
  return (
    <div className="bg-white border border-gray-200 rounded-xl p-4" data-testid="refund-ledger-panel">
      <p className="text-[10px] uppercase font-bold text-gray-500 mb-3">Refund ledger</p>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-2 text-sm">
        <div><p className="text-[10px] text-gray-500">Cap</p><p className="font-bold">₹{Number(ledger.cap || 0).toLocaleString('en-IN')}</p></div>
        <div><p className="text-[10px] text-gray-500">Refunded</p><p className="font-bold">₹{Number(ledger.total_refunded || 0).toLocaleString('en-IN')}</p></div>
        <div><p className="text-[10px] text-gray-500">Remaining</p><p className="font-bold text-emerald-700">₹{Number(ledger.remaining_refundable || 0).toLocaleString('en-IN')}</p></div>
        <div><p className="text-[10px] text-gray-500">PG status</p><p className="font-medium">{(ledger.refund_status || '—').replace(/_/g, ' ')}</p></div>
      </div>
      {(ledger.wallet_refunds > 0 || ledger.credit_refunds > 0) && (
        <p className="text-[10px] text-gray-500 mt-2" data-testid="refund-ledger-breakdown">
          Support refunds ₹{Number(ledger.ticket_payments_refunded || 0).toLocaleString('en-IN')}
          {ledger.wallet_refunds > 0 && ` · wallet ₹${Number(ledger.wallet_refunds).toLocaleString('en-IN')}`}
          {ledger.credit_refunds > 0 && ` · credit ₹${Number(ledger.credit_refunds).toLocaleString('en-IN')}`}
        </p>
      )}
    </div>
  );
}
